module.exports = __webpack_public_path__ + "img/3.21339ef2.png";